import { getFirebaseRemoteConfig } from './firebase';

export const defaultHomeLogo =
  'https://mindverseglobal.mindverse.com/assets/operation/default_logo.svg';

export const getHomeLogoUrl = () => {
  const config = getFirebaseRemoteConfig('awesome_feature6');

  return config || defaultHomeLogo;
};
